import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../helpers/emblaControls';
const classes = {
    activeTab: 'product-recommendations__tab--active',
    hasRecentlyViewed: 'product-recommendations__inner--has-recently-viewed',
};
const selectors = {
    productID: 'data-product-id',
    productHandle: 'data-product-handle',
    productRecommendations: '[data-product-recommendations]',
    productRecommendationsTab: '[data-product-recommendations-tab]',
    productRecommendationsTabActive: '.product-recommendations__tab--active',
    productRecommendationsTabIndicator: '[data-product-recommendations-tab-indicator]',
    productRecommendationsCarousel: '[data-product-recommendations-carousel]',
    productRecommendationsCarouselViewport: '[data-product-recommendations-carousel-viewport]',
    productRecommendationsCarouselPrev: '[data-product-recommendations-carousel-prev]',
    productRecommendationsCarouselNext: '[data-product-recommendations-carousel-next]',
    productRecentlyViewedCarousel: '[data-product-recently-viewed-carousel]',
    productRecentlyViewedCarouselViewport: '[data-product-recently-viewed-carousel-viewport]',
    productRecentlyViewedCarouselPrev: '[data-product-recently-viewed-carousel-prev]',
    productRecentlyViewedCarouselNext: '[data-product-recently-viewed-carousel-next]',
};
const productRecommendations = () => {
    const productRecommendations = document.querySelector(selectors.productRecommendations);
    if (productRecommendations) {
        const productID = productRecommendations.getAttribute(selectors.productID);
        const productHandle = productRecommendations.getAttribute(selectors.productHandle);
        // Tabs
        const tabs = productRecommendations.querySelectorAll(selectors.productRecommendationsTab);
        const indicator = productRecommendations.querySelector(selectors.productRecommendationsTabIndicator);
        tabs.forEach((tab) => {
            tab.addEventListener('mouseover', () => {
                const width = tab.offsetWidth;
                const left = tab.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            tab.addEventListener('mouseout', () => {
                const activeTab = productRecommendations.querySelector(selectors.productRecommendationsTabActive);
                const width = activeTab.offsetWidth;
                const left = activeTab.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            tab.addEventListener('click', () => {
                tabs.forEach((tab) => {
                    tab.classList.remove(classes.activeTab);
                });
                tab.classList.add(classes.activeTab);
            });
        });
        const events = ['load', 'resize'];
        events.forEach((event) => {
            window.addEventListener(event, () => {
                const activeTab = productRecommendations.querySelector(selectors.productRecommendationsTabActive);
                const width = activeTab.offsetWidth;
                const left = activeTab.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
        });
        // Recommendations
        const productRecommendationsCarousel = productRecommendations.querySelector(selectors.productRecommendationsCarousel);
        if (productRecommendationsCarousel) {
            fetch(window.Shopify.routes.root + 'recommendations/products?product_id=' + productID + '&limit=10&section_id=product-recommendations&intent=related')
                .then((response) => response.text())
                .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.embla__container');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsCarousel.querySelector('.embla__container').innerHTML = recommendations.innerHTML;
                }
            })
                .then(() => {
                const viewportNode = productRecommendationsCarousel.querySelector(selectors.productRecommendationsCarouselViewport);
                const prevButtonNode = productRecommendations.querySelector(selectors.productRecommendationsCarouselPrev);
                const nextButtonNode = productRecommendations.querySelector(selectors.productRecommendationsCarouselNext);
                const options = {
                    loop: true,
                    align: 'start',
                };
                const embla = EmblaCarousel(viewportNode, options);
                const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevButtonNode, nextButtonNode);
            })
                .then(() => {
                window.dispatchEvent(new CustomEvent('frank-green:recommendations-loaded'));
            });
        }
        // Recently Viewed
        /*
          This functionality works, however, the HTML has been commented out in product-recommendations.liquid until Phase 2
        */
        const productRecentlyViewedCarousel = productRecommendations.querySelector(selectors.productRecentlyViewedCarousel);
        if (productRecentlyViewedCarousel) {
            const viewedProducts = JSON.parse(sessionStorage.getItem('frank-green:recently-viewed-products'));
            viewedProducts.forEach((product) => {
                // If the product is not the current product...
                if (product != productHandle) {
                    fetch('/products/' + product + '?view=json')
                        .then((response) => {
                        return response.json();
                    })
                        .then((data) => {
                        const productTile = data.product.product_tile[0];
                        productRecentlyViewedCarousel.querySelector('.embla__container').innerHTML = productRecentlyViewedCarousel.querySelector('.embla__container').innerHTML + productTile;
                        productRecommendations.classList.add(classes.hasRecentlyViewed);
                    })
                        .then(() => {
                        const viewportNode = productRecentlyViewedCarousel.querySelector(selectors.productRecentlyViewedCarouselViewport);
                        const prevButtonNode = productRecommendations.querySelector(selectors.productRecentlyViewedCarouselPrev);
                        const nextButtonNode = productRecommendations.querySelector(selectors.productRecentlyViewedCarouselNext);
                        const options = {
                            loop: true,
                            align: 'start',
                        };
                        const embla = EmblaCarousel(viewportNode, options);
                        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevButtonNode, nextButtonNode);
                    });
                }
            });
        }
    }
};
export { productRecommendations };
